import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { PaymentServiceContractor } from 'services/payment-service';
import camelcaseKeys from 'camelcase-keys';
import { PostQrPayment, RequestCheckQrCode } from './payment-service.type';

export interface PaymentServiceRepositoryContractor {
  requestCheckQrCode: (qrid: string) => Observable<RequestCheckQrCode>;
  requestQrPayment: (qrid: string, payload: PostQrPayment) => Observable<string>;
}

export class PaymentServiceRepository implements PaymentServiceRepositoryContractor {
  private paymentService: PaymentServiceContractor;

  constructor(paymentService: PaymentServiceContractor) {
    this.paymentService = paymentService;
  }

  requestCheckQrCode = (qrid: string): Observable<RequestCheckQrCode> => {
    return this.paymentService.requestCheckQrCode(qrid).pipe(
      map((response) => {
        const newObj = camelcaseKeys(response?.data, { deep: true });
        return newObj;
      }),
    );
  };

  requestQrPayment = (qrid: string, payload: PostQrPayment): Observable<string> => {
    return this.paymentService
      .requestQrPayment(qrid, payload)
      .pipe(map((response) => response.token));
  };
}
